import style from '#src/client/common/layout/PagePadding.module.css';
import { splitProps } from 'solid-js';

function PagePadding(props) {
    const [local, others] = splitProps(props, [
        'class',
        'limitWidth',
    ]);

    const classes = () => {
        return [
            local.class,
            local.limitWidth ? style.limitWidth : '',
            style.box,
        ].join(' ');
    };

    return (
        <div {...others} class={classes()}>
            {props.children}
        </div>
    );
}

export default PagePadding;
